import { addEvent } from './addEvent';
import { chain } from './chain';
import { getScrollParent } from './getScrollParent';
import { opensKeyboard } from './opensKeyboard';
import { setStyle } from './setStyle';
const scrollIntoView = (scrollTarget) => {
    setTimeout(() => {
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 250);
};
const onWindowScroll = (_) => window.scrollTo(0, 0);
export const preventScrollMobileSafari = ({ allowPinchZoom, }) => {
    const { scrollX, scrollY } = window;
    let scrollable;
    let lastY = 0;
    let hasInput = false;
    let restoreScroll;
    const onFocus = (e) => {
        e.preventDefault();
        const visualViewport = typeof document !== 'undefined' && window.visualViewport;
        const target = e.target;
        if (visualViewport && opensKeyboard(target)) {
            const isKbVisible = visualViewport.height < window.innerHeight;
            if (!hasInput) {
                restoreScroll = chain(setStyle(document.body, 'overflow', 'hidden'), setStyle(document.body, 'marginTop', `-${scrollY}px`));
                hasInput = true;
            }
            if (isKbVisible) {
                scrollIntoView(target);
            }
            else {
                visualViewport.addEventListener('resize', scrollIntoView.bind(null, target), { once: true });
            }
        }
    };
    const onGesture = (e) => {
        if (!allowPinchZoom) {
            e.preventDefault();
        }
    };
    const onTouchEnd = (e) => {
        const target = e.target;
        if (opensKeyboard(target) && target !== document.activeElement) {
            e.preventDefault();
            target.style.transform = 'translateY(-2000px)';
            target.focus();
            requestAnimationFrame(() => {
                target.style.transform = '';
            });
        }
    };
    const onTouchMove = (e) => {
        if (!scrollable ||
            scrollable === document.documentElement ||
            scrollable === document.body) {
            e.preventDefault();
            return;
        }
        const { clientHeight, scrollHeight, scrollTop } = scrollable;
        const bottom = scrollHeight - clientHeight;
        const y = e.changedTouches[0].pageY;
        if ((scrollTop <= 0 && y > lastY) || (scrollTop >= bottom && y < lastY)) {
            e.preventDefault();
        }
        if (bottom === 0) {
            return;
        }
        lastY = y;
    };
    const onTouchStart = (e) => {
        scrollable = getScrollParent(e.target);
        if (scrollable === document.documentElement &&
            scrollable === document.body) {
            return;
        }
        lastY = e.changedTouches[0].pageY;
    };
    const restoreStyles = chain(setStyle(document.documentElement, 'paddingRight', `${window.innerWidth - document.documentElement.clientWidth}px`));
    const removeEvents = chain(...[
        ['gesturestart', onGesture],
        ['gesturechange', onGesture],
        ['gestureend', onGesture],
        ['touchstart', onTouchStart],
        ['touchmove', onTouchMove],
        ['touchend', onTouchEnd],
    ].map(([event, listener]) => addEvent(document, event, listener, {
        capture: true,
        passive: false,
    })), addEvent(document, 'focus', onFocus, true), addEvent(window, 'scroll', onWindowScroll));
    return () => {
        removeEvents();
        restoreStyles();
        if (hasInput) {
            restoreScroll === null || restoreScroll === void 0 ? void 0 : restoreScroll();
            window.scrollTo({ behavior: 'smooth', left: scrollX, top: scrollY });
        }
    };
};
//# sourceMappingURL=preventScrollMobileSafari.js.map